(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["industry-food-brands-solution"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('food-brand-solution-form');
    var success = document.querySelector('[data-form-success]');

    if (success) {
      window.setTimeout(function () {
        success.scrollIntoView({ block: 'center', behavior: 'smooth' });
        success.focus({ preventScroll: true });
      }, 120);
    }

    if (!form) {
      return;
    }

    form.addEventListener('submit', function () {
      if (form.checkValidity && !form.checkValidity()) {
        return;
      }

      var button = form.querySelector('[data-submit-button]');
      var label = form.querySelector('[data-submit-label]');
      var status = form.querySelector('[data-submit-status]');

      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      }

      if (label && button) {
        label.textContent = button.getAttribute('data-sending-label') || 'Sending...';
      }

      if (status) {
        status.hidden = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["industry-solution-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-industry-form-success]').forEach(function (success) {
      window.setTimeout(function () {
        success.scrollIntoView({ block: 'center', behavior: 'smooth' });
        success.focus({ preventScroll: true });
      }, 120);
    });

    document.querySelectorAll('.industry-solution__form').forEach(function (form) {
      form.addEventListener('submit', function () {
        if (form.checkValidity && !form.checkValidity()) {
          return;
        }

        var button = form.querySelector('[data-submit-button]');
        var label = form.querySelector('[data-submit-label]');
        var status = form.querySelector('[data-submit-status]');

        if (button) {
          button.setAttribute('aria-busy', 'true');
          button.disabled = true;
        }

        if (label && button) {
          label.textContent = button.getAttribute('data-sending-label') || 'Sending...';
        }

        if (status) {
          status.hidden = false;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["packaging-decision-tool"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const nearestBracket = (value) => {
      const brackets = [50, 100, 150, 200, 250, 350, 500, 750, 1000, 1500, 2000, 3000, 5000, 10000];
      return brackets.find((item) => item >= value) || Math.ceil(value / 1000) * 1000;
    };

    const updateResult = (form, values) => {
      Object.entries(values).forEach(([key, value]) => {
        form.closest('.packaging-tool__workspace').querySelectorAll(`[data-result="${key}"]`).forEach((node) => {
          if (key === 'meter') node.style.setProperty('--meter', value);
          else node.textContent = value;
        });
      });
    };

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-packaging-calculator]');
      if (!form) return;
      event.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      const data = new FormData(form);
      const kind = form.dataset.packagingCalculator;

      if (kind === 'volume') {
        const weight = Number(data.get('weight'));
        const density = Number(data.get('density'));
        const headspace = Number(data.get('headspace')) / 100;
        if (!weight || !density || headspace < 0 || headspace >= 0.6) return;
        const productVolume = weight / density;
        const planningCapacity = productVolume / (1 - headspace);
        if (planningCapacity > 20000) {
          updateResult(form, {
            headline: 'Outside this pouch calculator’s screening range',
            detail: `${Math.ceil(planningCapacity).toLocaleString()} mL calculated planning capacity. Review a qualified large-format pouch, bag-in-box, liner, or rigid-container system instead of selecting a nominal pouch from this tool.`,
            meter: '100%',
            note: 'Confirm handling loads, fitment and lifting method, filling equipment, closure, transport, and filled-pack testing with the relevant system suppliers.'
          });
          return;
        }
        const bracket = nearestBracket(planningCapacity);
        updateResult(form, {
          headline: `${Math.ceil(planningCapacity)} mL minimum planning capacity`,
          detail: `${Math.round(productVolume)} mL estimated product volume with ${Math.round(headspace * 100)}% planned headspace. Start sample trials near a ${bracket} mL nominal capacity, then confirm the actual pouch geometry and filled appearance.`,
          meter: `${Math.min(100, Math.max(8, Math.round((productVolume / bracket) * 100)))}%`,
          note: data.get('behavior') === 'aerated' ? 'Powders or aerated products can settle after filling; test both fresh-fill and settled volume.' : data.get('behavior') === 'particles' ? 'Particles can change flow, trapped air, and seal cleanliness; run an actual product trial.' : 'Record actual fill height, headspace, seal cleanliness, filled thickness, and shelf stance.'
        });
      }

      if (kind === 'spout') {
        const band = data.get('viscosity');
        const particle = Number(data.get('particle')) || 0;
        const ranges = {
          low: [8.5, 10], medium: [10, 13], high: [13, 16], extreme: [16, 22]
        };
        let [min, max] = ranges[band] || ranges.medium;
        const particleScreen = particle * 3;
        if (particleScreen > 22) {
          const route = data.get('route');
          updateResult(form, {
            headline: 'Specialist fitment or alternate filling path required',
            detail: `A provisional 3× clearance screen for a ${particle} mm largest particle exceeds the 22 mm upper boundary of this matrix. Do not extrapolate a bore size from this result.`,
            meter: '100%',
            note: route === 'open' ? 'Keep open-top filling under review, then validate consumer dispensing, fitment, closure, hygiene, and product behavior with real samples.' : 'Review open-top filling, a specialist fitment, another package format, or product/process changes with the filler and fitment supplier before sampling.'
          });
          return;
        }
        if (particleScreen > min) min = Math.ceil(particleScreen * 2) / 2;
        if (min > max) max = 22;
        const route = data.get('route');
        const routeNote = route === 'through' ? 'Confirm the machine nozzle, spout ID, rail/neck geometry, pump, temperature, cap feed, and torque together.' : route === 'open' ? 'Open-top filling may reduce spout flow restrictions during fill, but the fitment, top-seal process, dispense rate, and closure still need validation.' : 'For manual or pilot filling, reproduce the future production route before scale-up.';
        updateResult(form, {
          headline: min === max ? `Review ${min} mm-plus specialist fitments` : `Review ${min}–${max} mm candidate bore`,
          detail: `This range combines a practitioner viscosity band with a provisional 3× largest-particle clearance screen. It is not a final specification or an industry standard.`,
          meter: `${Math.min(100, Math.max(15, Math.round((min / 22) * 100)))}%`,
          note: routeNote
        });
      }

      if (kind === 'filling') {
        const checks = [...form.querySelectorAll('input[type="checkbox"]')];
        const checked = checks.filter((item) => item.checked).length;
        const blockers = checks.filter((item) => item.dataset.blocker === 'true' && !item.checked).map((item) => item.dataset.short);
        const percent = Math.round((checked / checks.length) * 100);
        let headline = 'Specification gaps remain';
        if (percent >= 90 && blockers.length === 0) headline = 'Ready to define the sample trial';
        else if (blockers.length >= 3) headline = 'Resolve critical inputs before sampling';
        updateResult(form, {
          headline,
          detail: `${checked} of ${checks.length} planning items confirmed. ${blockers.length ? `Critical gaps: ${blockers.join(', ')}.` : 'No critical planning gaps are marked.'}`,
          meter: `${percent}%`,
          note: percent >= 90 ? 'Document the exact line settings, sample size, acceptance limits, test sequence, and change-control owner before approval.' : 'Send the missing items with representative product and equipment information before locking the pouch dieline or fitment.'
        });
      }

      if (kind === 'moq') {
        const skus = Number(data.get('skus')) || 1;
        const units = Number(data.get('units')) || 0;
        const perSku = Math.floor(units / skus);
        const shared = data.get('shared') === 'yes';
        const finish = data.get('finish');
        const artwork = data.get('artwork');
        let route = 'Stock pouch + label or pilot sample path';
        let explanation = 'This keeps commitment low while the product, artwork, or specification is still changing.';
        if (perSku >= 200 && units < 30000 && shared && artwork !== 'concept') {
          route = skus > 1 ? 'Digital-print multi-SKU route' : 'Low-MOQ digital-print route';
          explanation = 'Shared size and material can make SKU splitting more practical without plate fees, subject to format, print, and production review.';
        }
        if (units >= 30000 && perSku >= 5000 && artwork === 'ready' && finish !== 'complex') {
          route = 'Compare digital with high-volume print economics';
          explanation = 'At this volume, unit economics may justify evaluating rotogravure or another production route against digital flexibility and setup cost.';
        }
        if (!shared && skus > 3) {
          route = 'Simplify specifications before quoting';
          explanation = 'Different sizes or materials across many SKUs fragment production. Group products into shared specification families first.';
        }
        const readiness = Math.min(100, (shared ? 30 : 10) + (artwork === 'ready' ? 35 : artwork === 'working' ? 20 : 5) + (perSku >= 200 ? 25 : 8) + (finish === 'standard' ? 10 : 4));
        updateResult(form, {
          headline: route,
          detail: `${units.toLocaleString()} total units across ${skus} SKU${skus === 1 ? '' : 's'} equals about ${perSku.toLocaleString()} units per SKU. ${explanation}`,
          meter: `${readiness}%`,
          note: 'The estimator does not quote a price or guarantee MOQ. Final feasibility depends on pouch format, material structure, fitment, print coverage, compliance, and production scheduling.'
        });
      }

      if (kind === 'cost') {
        const skus = Math.max(1, Number(data.get('skus')) || 1);
        const perSku = Math.max(1, Number(data.get('per_sku')) || 1);
        const totalUnits = skus * perSku;
        const stage = data.get('stage');
        const change = data.get('change');
        const demand = data.get('demand');
        const storage = data.get('storage');
        let digitalScore = 0;
        let gravureScore = 0;
        if (perSku <= 1000) digitalScore += 4;
        else if (perSku <= 5000) digitalScore += 3;
        else if (perSku <= 10000) { digitalScore += 1; gravureScore += 1; }
        else gravureScore += 4;
        if (skus >= 4) digitalScore += 3;
        else if (skus >= 2) digitalScore += 1;
        else gravureScore += 1;
        if (stage === 'testing') digitalScore += 3;
        else if (stage === 'growing') { digitalScore += 1; gravureScore += 1; }
        else gravureScore += 3;
        if (change === 'likely') digitalScore += 3;
        else if (change === 'maybe') digitalScore += 1;
        else gravureScore += 2;
        if (demand === 'uncertain') digitalScore += 2;
        else if (demand === 'moderate') { digitalScore += 1; gravureScore += 1; }
        else gravureScore += 2;
        if (storage === 'limited') digitalScore += 2;
        else if (storage === 'some') { digitalScore += 1; gravureScore += 1; }
        else gravureScore += 2;
        const difference = Math.abs(digitalScore - gravureScore);
        const nearTie = difference <= 1;
        const digitalLower = digitalScore > gravureScore;
        const winner = nearTie ? 'Both routes are worth comparing' : digitalLower ? 'Digital is more likely to deliver the lower total cost' : 'Rotogravure is more likely to deliver the lower total cost';
        const digitalPosition = nearTie ? 'Competitive—include it in the quote comparison' : digitalLower ? 'Stronger value fit for this plan' : 'Useful mainly if flexibility remains important';
        const gravurePosition = nearTie ? 'Competitive—include it in the quote comparison' : digitalLower ? 'Less likely to be the best-value starting point' : 'Stronger value fit for this plan';
        let valueSignal = 'Request both routes against the same pouch specification and delivery terms.';
        if (digitalLower) valueSignal = 'Start with digital printing: it better matches this quantity, SKU mix, and need to limit change or inventory risk.';
        if (!nearTie && !digitalLower) valueSignal = 'Start with rotogravure: stable demand and sufficient volume per design make it the stronger value candidate.';
        const confidence = Math.min(92, 54 + (difference * 6));
        updateResult(form, {
          headline: winner,
          detail: `${totalUnits.toLocaleString()} planned packs across ${skus} design${skus === 1 ? '' : 's'}—about ${perSku.toLocaleString()} per design. No price input is used or displayed.`,
          digital: digitalPosition,
          gravure: gravurePosition,
          value: valueSignal,
          meter: `${confidence}%`,
          note: 'This is a directional planning result, not a quotation. Confirm the final lower-cost route with the same dimensions, material, print coverage, finish, closure, testing, delivery terms, and quality requirements.'
        });
      }

      if (kind === 'barrier') {
        const product = data.get('product');
        const risk = data.get('risk');
        const process = data.get('process');
        const transparency = data.get('transparency');
        const circularity = data.get('circularity');
        const productPaths = {
          powder: ['Moisture-barrier pouch review', 'Measure water-vapor sensitivity, powder dust in the seal, zipper use, and storage humidity.'],
          dry_food: ['Oxygen, moisture and aroma barrier review', 'Define crispness, oxidation, aroma retention, grease, puncture, and intended shelf life.'],
          oily: ['High oxygen, aroma and grease-resistance review', 'Review oil migration, oxidation, light exposure, sealant compatibility, and filled-pack storage.'],
          aqueous: ['Liquid compatibility and seal-integrity review', 'Review water activity, acidity, aroma, sealant, drop performance, and leakage.'],
          personal_care: ['Formula-compatibility and leak-resistance review', 'Screen surfactants, fragrance, alcohol, oils, stress cracking, fitment welds, and repeated dispensing.'],
          industrial: ['Chemical-compatibility and mechanical-strength review', 'Obtain full formulation, safety, transport, permeation, puncture, fitment, and regulatory requirements.']
        };
        let [headline, detail] = productPaths[product] || productPaths.aqueous;
        if (process === 'retort') {
          headline = 'Qualified retort structure and process review';
          detail = 'Retort packaging requires a structure, seal system, ink and adhesive package, process schedule, equipment, product and validation program qualified together by appropriate specialists.';
        } else if (process === 'hot') {
          headline = 'Hot-fill-compatible structure review';
          detail += ' Add actual fill temperature, cooling profile, hold time, pouch support and thermal seal requirements.';
        } else if (process === 'frozen') {
          headline = 'Low-temperature toughness and seal review';
          detail += ' Add frozen impact, flex cracking, seal behavior, thaw conditions and distribution testing.';
        }
        const riskNotes = {
          moisture: 'Set a measurable WVTR or product-performance target instead of asking only for “high barrier.”',
          oxygen: 'Set an oxygen/aroma target and review headspace, light, seal integrity and real shelf-life evidence.',
          light: 'Opaque, metallized or foil-containing candidates may help, but transparency and recycling goals change the shortlist.',
          chemical: 'Compatibility must include film, sealant, adhesive, ink, fitment and cap over the intended storage period.',
          puncture: 'Review abuse resistance, flex cracking, drop, compression, sharp particles and distribution conditions.'
        };
        let note = riskNotes[risk] || riskNotes.moisture;
        if (transparency === 'required') note += ' Because product visibility is required, screen transparent high-barrier options before opaque foil or metallized routes.';
        if (circularity === 'mono') note += ' A mono-material candidate should be tested against the same barrier, sealing, stiffness, fitment and process requirements; recyclability claims remain market-specific.';
        if (circularity === 'paper') note += ' Treat paper as an appearance layer unless the full structure and local collection system support the intended environmental claim.';
        updateResult(form, {
          headline,
          detail,
          meter: process === 'retort' ? '100%' : risk === 'chemical' ? '85%' : '65%',
          note
        });
      }

      if (kind === 'artwork') {
        const checks = [...form.querySelectorAll('input[type="checkbox"]')];
        const checked = checks.filter((item) => item.checked).length;
        const blockers = checks.filter((item) => item.dataset.blocker === 'true' && !item.checked).map((item) => item.dataset.short);
        const percent = Math.round((checked / checks.length) * 100);
        let headline = 'Artwork package needs prepress work';
        if (percent >= 90 && blockers.length === 0) headline = 'Ready for supplier preflight';
        else if (percent >= 65 && blockers.length <= 1) headline = 'Nearly ready—resolve the remaining controls';
        updateResult(form, {
          headline,
          detail: `${checked} of ${checks.length} artwork controls confirmed. ${blockers.length ? `Critical gaps: ${blockers.join(', ')}.` : 'No critical preflight blockers are marked.'}`,
          meter: `${percent}%`,
          note: percent >= 90 && blockers.length === 0 ? 'Send the source artwork, linked files, approved dieline, version matrix and written finish instructions for supplier preflight and proofing.' : 'Resolve critical gaps before requesting a production proof. Regulatory copy, barcode verification and legal approval remain the brand owner’s responsibility.'
        });
      }

      if (kind === 'rfq') {
        const product = data.get('product');
        const format = data.get('format');
        const fill = String(data.get('fill') || '').trim();
        const shelf = String(data.get('shelf') || '').trim();
        const process = data.get('process');
        const skus = Math.max(1, Number(data.get('skus')) || 1);
        const units = Math.max(1, Number(data.get('units')) || 1);
        const total = skus * units;
        const machine = String(data.get('machine') || '').trim();
        const market = String(data.get('market') || '').trim();
        const artwork = data.get('artwork');
        const timing = String(data.get('timing') || '').trim();
        const missing = [];
        if (!fill) missing.push('net fill');
        if (!shelf) missing.push('target shelf life');
        if (!machine || process === 'Not confirmed') missing.push('filling equipment or process');
        if (!market) missing.push('destination market');
        if (!timing) missing.push('sample and launch timing');
        const artworkLabel = artwork === 'ready' ? 'print-ready artwork' : artwork === 'working' ? 'artwork in progress' : 'concept-stage artwork';
        const completeness = Math.max(20, 100 - (missing.length * 15) - (artwork === 'concept' ? 10 : 0));
        updateResult(form, {
          headline: missing.length ? 'RFQ scope built—technical inputs still missing' : 'Ready for supplier RFQ review',
          detail: `${total.toLocaleString()} total units across ${skus} SKU${skus === 1 ? '' : 's'} (${units.toLocaleString()} per SKU). ${missing.length ? `Still confirm: ${missing.join(', ')}.` : 'The core commercial and application fields are present.'}`,
          brief: `${product}; ${format}; ${fill || 'net fill not confirmed'}; ${process}; ${shelf || 'shelf life not confirmed'}; ${skus} SKU${skus === 1 ? '' : 's'} × ${units.toLocaleString()} units; market: ${market || 'not confirmed'}; ${artworkLabel}; machine/co-packer: ${machine || 'not confirmed'}; timing: ${timing || 'not confirmed'}.`,
          meter: `${completeness}%`,
          note: missing.length ? 'Resolve the missing fields, then add dimensions, material or barrier targets, closure, print finish, test plan, freight basis and acceptance criteria.' : 'Send the same scope to every supplier, then compare specification, validation, lead time, setup, freight terms, total landed cost and change-control process—not unit price alone.'
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
